import z from "zod/v4";

export const WorkflowEventTypeList = [
  "session.created",
  "session.resumed",
  "node.started",
  "node.completed",
  "node.failed",
  "input.required",
  "input.received",
  "session.completed",
  "session.timeout",
  "session.error",
] as const;

export const WorkflowEventTypeSchema = z.enum(WorkflowEventTypeList);
export type WorkflowEventType = z.infer<typeof WorkflowEventTypeSchema>;
